<template>
  <v-btn
    v-if="$vuetify.breakpoint.smAndDown"
    small
    text
    :to="/presupuesto/ + numdoc"
    target="_blank"
  >
    <v-icon class="ml-5">mdi-share-variant</v-icon>
  </v-btn>
</template>

<script>
export default {
  props: {
    numdoc: Number,
  },
};
</script>
